import { ToggleButton } from '@te-whatu-ora/anatomic'
import type { BooleanInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'

export default function BooleanInput(props: BooleanInputProps) {
  const { value, disabled, onChange } = props

  function handleChange(newValue: string) {
    switch (newValue) {
      case 'yes':
        return onChange(true)
      case 'no':
        return onChange(false)
      default:
        return onChange(null)
    }
  }

  return (
    <InputFieldset {...props}>
      <ToggleButton
        disabled={disabled}
        defaultValue={
          (value === true && 'yes') || (value === false && 'no') || undefined
        }
        labelLeft='Yes'
        valueLeft='yes'
        labelRight='No'
        valueRight='no'
        onChange={handleChange}
      />
    </InputFieldset>
  )
}
